const LinkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      width="512"
      height="512"
      fill="none"
      viewBox="0 0 512 512"
      aria-hidden="true"
    >
      <path
        fill="#000"
        d="M227.109 285.291c8.517 8.101 8.517 21.397 0 29.498-8.101 8.102-21.397 8.102-29.498 0-40.509-40.508-40.509-106.361 0-146.869l73.538-73.539c40.509-40.508 106.361-40.508 146.87 0 40.508 40.509 40.508 106.361 0 146.87l-30.953 30.952c.208-17.034-2.493-34.068-8.309-50.272l9.763-9.971c24.513-24.305 24.513-63.775 0-88.08-24.305-24.513-63.775-24.513-88.08 0l-73.331 73.331c-24.513 24.305-24.513 63.775 0 88.08zm58.582-88.08c8.101-8.102 21.397-8.102 29.498 0 40.509 40.508 40.509 106.361 0 146.869l-73.538 73.539c-40.509 40.508-106.361 40.508-146.87 0-40.508-40.509-40.508-106.361 0-146.87l30.953-30.952c-.208 17.034 2.493 34.068 8.31 50.479l-9.764 9.764c-24.513 24.305-24.513 63.775 0 88.08 24.305 24.513 63.775 24.513 88.08 0l73.331-73.331c24.513-24.305 24.513-63.775 0-88.08-8.517-8.101-8.517-21.397 0-29.498z"
      ></path>
    </svg>
  );
};

export default LinkIcon;
